module.exports = ".btn-inscripcion {\n  margin-bottom: 20px;\n  margin-top: 13px;\n  text-align: right; }\n"